import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { useWithPerimeterXCaptcha } from '../useWithPerimeterXCaptcha';

import { socialPostPreview } from './api/api';
import type { SocialPostPreviewQuery } from './api/api.graphql';

const QUERY_KEY = 'homepage-social-post-preview';

/**
 * Fetches display metadata (title + thumbnail) for an attached social post URL, for showing
 * a preview before the user submits for draft generation. Disabled (no request) while `url`
 * is undefined, e.g. before a post is attached.
 */
export function useSocialPostPreview(
	url: string | undefined,
): UseQueryResult<SocialPostPreviewQuery['socialPostPreview']> {
	const utilityContext = useUtilityContext();
	const withPerimeterXCaptcha = useWithPerimeterXCaptcha();

	return useQuery({
		queryKey: [QUERY_KEY, url],
		queryFn: async () => withPerimeterXCaptcha(async () => socialPostPreview(url as string, utilityContext)),
		enabled: url !== undefined,
	});
}
